export enum Type {
  BASIC = 'BASIC',
  SUPP = 'SUPP',
  COMPANION = 'COMPANION',
}

export enum Status {
  NEW = 'NEW',
  UPGRADE = 'UPGRADE',
  EXISTING = 'EXISTING',
}

export enum Display {
  WELCOME_VIDEO = 'WELCOME_VIDEO',
  BENEFITS_SETUP = 'BENEFITS_SETUP',
  BANNER = 'BANNER',
}

export type Refresh = {
  accountToken: string,
  accountKey: string,
  type: Type,
  display: Array<Display>,
  status: Status,
  cleanCardArtUrl: string,
};

export type CardVitals = {
  productRefresh?: {
    data: Array<Refresh>,
  },
};

export type ExploreModuleProps = {
  refreshData: Refresh,
  onLoad?: () => void,
  onError?: () => void,
  videoEnded?: boolean,
};
